angular.module('tasks').directive('taskChecklist', ["PATH", function(PATH){
  return {
    restrict: 'E',
    scope: {
      checklist: '=',
      onItemChange: '&',
      isDisabled: '&'
    },
    templateUrl: PATH.components + 'taskManagement/checklist/view.html',
    transclude: true,
    link: function ($scope) {

      $scope.checklist.items.map(function(item){
        item.completed = !item.isOpen;
      });

      $scope.isDisabledItem = function(item){
        return ['transactionprocessing','accountvalidation','accountreconciliation','inventoryprocessing','dsprocessing'].indexOf(item.type) > -1 || $scope.isDisabled();
      };

      $scope.updateProgress = function(item){
        if(item){
          $scope.onItemChange({item:item});
        }
        var doneNumber = _.filter($scope.checklist.items, function(item){
          return item.completed;
        }).length;
        var total = $scope.checklist.items.length;
        $scope.checklistProgress = Math.ceil((doneNumber / total)*100);
      }

      $scope.updateProgress();
    }
  }
}]);



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/taskManagement/checklist/directive.js